function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Asset 4");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("rect", {
  className: "background",
  width: 768,
  height: 100
}), React.createElement("path", {
  className: "wave",
  d: "M768,78.1A51.11,51.11,0,0,1,754,80c-16.52,0-29-15-43.45-32.28C691.9,25.35,670.75,0,634,0h0c-34.53,0-54.71,23.07-72.52,43.41C544.3,63.05,529.46,80,504,80c-16.52,0-29-15-43.45-32.28C441.9,25.35,420.75,0,384,0h0c-36.74,0-57.89,25.35-76.54,47.72C293,65,280.52,80,264,80c-25.46,0-40.3-17-57.47-36.59C188.72,23.07,168.54,0,134,0h0C97.25,0,76.1,25.35,57.45,47.72,43,65,30.52,80,14,80A51.11,51.11,0,0,1,0,78.1V98.64A71.88,71.88,0,0,0,14,100c25.88,0,42.62-20.07,58.8-39.47C90.19,39.69,106.61,20,134,20c25.46,0,40.3,17,57.47,36.58C209.28,76.93,229.46,100,264,100c25.88,0,42.62-20.07,58.8-39.47C340.19,39.69,356.61,20,384,20s43.81,19.69,61.2,40.53C461.38,79.93,478.12,100,504,100c34.54,0,54.72-23.07,72.53-43.42C593.7,37,608.54,20,634,20c27.39,0,43.81,19.69,61.2,40.53C711.38,79.93,728.12,100,754,100a71.88,71.88,0,0,0,14-1.36Z"
})));

var SvgWaveFull = function SvgWaveFull(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 768 100",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWaveFull, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wave-full.09c7ff9a.svg";
export { ForwardRef as ReactComponent };